<form [formGroup]="repairCodeSearchTextForm">
    <div>
        <mc-input hiddenlabel placeholder="Search for a repair code" fit="small" ngDefaultControl
            formControlName="SearchText" (keyup.enter)="applySearchTextFilters()" icon="magnifying-glass"
            [clearbutton]=true (clearbuttonclick)="applySearchTextFilters()">
        </mc-input>
    </div>
</form>
